import { SET_PAYMENT_METHODS } from "../mutation-types";
import Vue from "vue";
import _ from "lodash";

const state = {
  paymentMethods: [],
  currentPaymentMethod: {
    id: "paypal",
    name: "",
    icon: "",
  },
};

const mutations = {
  [SET_PAYMENT_METHODS](state, methods) {
    _.remove(methods, function (method) {
      return (
        method.id !== "paypal" &&
        method.id !== "wechatpay" &&
        method.id !== "alipay_global" &&
        method.id !== "paymentwall" &&
        method.id !== "stripe" &&
        method.id !== "airwallex" &&
        method.id !== "mugglepay"
      );
    });
    state.paymentMethods = methods;
  },
  setDefaultPaymentMethod(state) {
    state.currentPaymentMethod = state.paymentMethods[0];
  },
  setCurrentPaymentMethod(state, method) {
    state.currentPaymentMethod = method;
  },
};

const actions = {
  getPaymentMethods({ commit }) {
    return new Promise(function (resolve, reject) {
      Vue.http.get("api/v2/extended-payment-methods").then((response) => {
        resolve(response);
        if (response.data.code === 0) {
          commit(SET_PAYMENT_METHODS, response.data.data);
        }
      }).catch((err) => {
        reject(err)
      });
    });
  },
};

export default {
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/paymentMethods.js